import { AxiosResponse } from 'axios'
import { DataSearchViewModel, Guid, DocumentTypeV1, ApiResult } from '../api'
import { useApiClient } from './useApiClient'

export const useDataSearchApi = () => {
  const apiClient = useApiClient()

  const performSearch = async (
    customerAgencyId: Guid,
    selectedType: DocumentTypeV1,
    searchValue: string,
  ) => {
    const response = await apiClient.request<
      void,
      AxiosResponse<ApiResult<DataSearchViewModel>>
    >({
      url: 'api/dataSearch',
      method: 'get',
      params: {
        customerAgencyId,
        selectedType,
        searchValue,
      },
      withCredentials: true,
    })

    if (
      response.status === 200 &&
      response.data.isSuccess &&
      response.data?.data?.results
    )
      return response.data.data.results
  }

  return {
    performSearch,
  }
}
